import React, { Component } from 'react';
import FetchRSS from './actions/fetchrss';
import Alert from './components/alert';
import Filter from './components/filter';
import './App.css';

class App extends Component {
  constructor() {
    super();
    this.state = {
      items: []
    };

    this.updateRss = this.updateRss.bind(this);
    this.updateList = this.updateList.bind(this);
  }

 componentDidMount() {
    this.updateList();
    if(this.state.items.length === 0)
      this.updateRss(false);
    setInterval(this.updateRss, 20000);

    if(window.Notification) {
      Notification.requestPermission().then(function(result) {
        console.log(result);
      });
    }
  }

  async updateRss(showNotification = true) {
    let feed = await FetchRSS.do(showNotification);

    feed.sort((a, b) => {
      if(a.getExpires() > b.getExpires())
        return 1;
      return 0;
    })
    this.setState({ items: FetchRSS.filter(feed)});
  }

  updateList() {
    let items = FetchRSS.getItems();

    items.sort((a, b) => {
      if(a.getExpires() > b.getExpires())
        return 1;
      return 0;
    })
    this.setState({ items: FetchRSS.filter(items)});
  }

  render() {
    return (
      <div className="App">
          <Filter updateList={this.updateList} />
          {this.state.items.map((item, i) => <Alert key={i} item={item} /> )}
          <footer>
            Created by <a href="mailto:gust42@gmail.com">gust</a>, 2017
          </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js